import { render } from "./CountyOrdinance.vue?vue&type=template&id=558a4cdc"
import script from "./CountyOrdinance.vue?vue&type=script&lang=ts"
export * from "./CountyOrdinance.vue?vue&type=script&lang=ts"
script.render = render

export default script